import { useState } from "react";
import {
  fetchCategoriesTree,
  createCategory,
  updateCategory,
  fetchOrganizerCategories,
  deleteCategory as deleteCategoryApi,
} from "../../../api/productCategory.api";

export const useProductCategory = () => {
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadCategories = async (company_id) => {
    setLoading(true);
    const res = await fetchCategoriesTree({ company_id });
    setData(res.data?.data || []);
    setLoading(false);
  };

  const loadCategoriesByOrganizer = async (company_id) => {
  try {
    const res = await fetchOrganizerCategories(company_id);
    setCategories(res.data?.data || []);
  } catch (error) {
    console.error("Failed to load categories", error);
    setCategories([]);
  }
};


  const addCategory = (payload) => createCategory(payload);
  const editCategory = (id, payload) => updateCategory(id, payload);
  
  const deleteCategory = async (id, payload) => {
    const res = await deleteCategoryApi(id, payload);
    return res.data;
  };



  return {
    data,
    categories,
    loading,
    loadCategories,
    loadCategoriesByOrganizer,
    addCategory,
    editCategory,
    deleteCategory,
  };
};
